import { StringHash } from '@app/shared/utils/utils-types';

export type FieldTitlesByTopicType = StringHash<StringHash<string>>;

export const customFieldsDefault: FieldTitlesByTopicType = {};
export const customFields: FieldTitlesByTopicType = {};

export function assignMergedFieldStrings(
  target: FieldTitlesByTopicType,
  systemResponse: FieldTitlesByTopicType,
  templateResponse: FieldTitlesByTopicType,
) {
  // Clear existing keys
  for (const key in target) {
    if (Object.prototype.hasOwnProperty.call(target, key)) {
      delete target[key];
    }
  }

  // Apply system-level first (base)
  if (systemResponse) {
    for (const topicTypeName in systemResponse) {
      if (Object.prototype.hasOwnProperty.call(systemResponse, topicTypeName)) {
        target[topicTypeName] = target[topicTypeName] || {};
        for (const fieldName in systemResponse[topicTypeName]) {
          if (Object.prototype.hasOwnProperty.call(systemResponse[topicTypeName], fieldName)) {
            target[topicTypeName][fieldName] = systemResponse[topicTypeName][fieldName];
          }
        }
      }
    }
  }

  // Apply template-level on top (overrides system)
  if (templateResponse) {
    for (const topicTypeName in templateResponse) {
      if (Object.prototype.hasOwnProperty.call(templateResponse, topicTypeName)) {
        target[topicTypeName] = target[topicTypeName] || {};
        for (const fieldName in templateResponse[topicTypeName]) {
          if (Object.prototype.hasOwnProperty.call(templateResponse[topicTypeName], fieldName)) {
            target[topicTypeName][fieldName] = templateResponse[topicTypeName][fieldName];
          }
        }
      }
    }
  }
}
